import { SearchJobForm } from './types'

export const INITIAL_VALUES: SearchJobForm = {
  client: '',
  name: '',
}
